// shared/store/filters/filtersSlice.ts
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { EDealType, EOfferType } from 'shared/types/features';
import type { TFiltersState } from 'shared/types/redux';

const initialState: TFiltersState = {
  dealType: null,
  offerType: null,
};

const filtersSlice = createSlice({
  name: 'filters',
  initialState,
  reducers: {
    setDealType(state, action: PayloadAction<EDealType>) {
      state.dealType = action.payload;
    },
    setOfferType(state, action: PayloadAction<EOfferType>) {
      state.offerType = action.payload;
    },
  },
});

export const { setDealType, setOfferType } = filtersSlice.actions;
export const filtersReducer = filtersSlice.reducer;
